import { useQueryClient as q, useMutation as d, useQuery as l } from "@tanstack/react-query";
import c from "./courses.api.js";
import { teachurKeys as n } from "../../constants/teachurKeys.js";
import { addCourseInstructorOptimistically as C, removeCourseInstructorOptimistically as i } from "./courses.updater.js";
const v = (e, u) => l({
  ...u,
  queryKey: n.courses.detail(e),
  queryFn: async () => (await c.get(e)).data,
  enabled: !!e
}), w = (e, u) => l({
  ...u,
  queryKey: [...n.courses.list(), e],
  queryFn: async () => (await c.list(e)).data
}), F = (e) => d({
  ...e,
  mutationFn: async ({ userId: u, courseId: r, status: s }) => (await c.updateCourseStatusForAdmin(u, r, s)).data
}), M = (e, u) => l({
  ...u,
  queryKey: n.users.userCourses(e),
  queryFn: async () => (await c.getUserCourses(e)).data,
  enabled: !!e
}), g = (e, u) => l({
  ...u,
  queryKey: n.courses.available(e),
  queryFn: async () => (await c.getAvailable(e)).data
}), f = (e, u) => l({
  ...u,
  queryKey: n.courses.completion(e),
  queryFn: async () => (await c.getCompletion(e)).data,
  enabled: !!e
}), G = (e, u) => l({
  staleTime: 300 * 1e3,
  ...u,
  queryKey: n.courses.lessons(e),
  queryFn: async () => (await c.getLessons(e)).data,
  enabled: !!e
}), b = (e, u) => l({
  staleTime: 60 * 1e3,
  ...u,
  queryKey: n.courses.objectives(e),
  queryFn: async () => (await c.getObjectives(e)).data,
  // Caller can disable with options.enabled = false, but a missing/zero
  // courseId still prevents the query from firing.
  enabled: ((u == null ? void 0 : u.enabled) ?? !0) && !!e
}), A = (e) => {
  const u = q();
  return d({
    ...e,
    mutationFn: async ({ courseId: r, userId: s }) => c.addCourse(r, s),
    onSuccess: (r, s, ...a) => {
      var t;
      u.invalidateQueries({ queryKey: n.courses.available() }), u.invalidateQueries({ queryKey: n.courses.list() }), u.invalidateQueries({ queryKey: ["degrees", "user-courses"] }), (t = e == null ? void 0 : e.onSuccess) == null || t.call(e, r, s, ...a);
    }
  });
}, R = (e) => {
  const u = q();
  return d({
    ...e,
    mutationFn: async ({ courseId: r, userId: s }) => c.removeCourse(r, s),
    onSuccess: (r, s, ...a) => {
      var t;
      u.invalidateQueries({ queryKey: n.courses.list() }), u.invalidateQueries({ queryKey: n.courses.available() }), u.invalidateQueries({ queryKey: ["degrees", "user-courses"] }), (t = e == null ? void 0 : e.onSuccess) == null || t.call(e, r, s, ...a);
    }
  });
}, E = (e) => {
  const u = q();
  return d({
    ...e,
    mutationFn: async (r) => c.start(r),
    onSuccess: (r, s, a, ...t) => {
      var y;
      u.invalidateQueries({ queryKey: n.courses.list() }), u.invalidateQueries({ queryKey: n.courses.detail(s) }), (y = e == null ? void 0 : e.onSuccess) == null || y.call(e, r, s, a, ...t);
    }
  });
}, O = (e) => {
  const u = q();
  return d({
    ...e,
    mutationFn: async (r) => c.pause(r),
    onSuccess: (r, s, a, ...t) => {
      var y;
      u.invalidateQueries({ queryKey: n.courses.list() }), u.invalidateQueries({ queryKey: n.courses.detail(s) }), (y = e == null ? void 0 : e.onSuccess) == null || y.call(e, r, s, a, ...t);
    }
  });
}, j = (e, u, r) => l({
  ...r,
  queryKey: ["userCourse", e, u],
  queryFn: async () => (await c.getStudentCourse(e, u)).data,
  enabled: !!e && !!u
}), D = (e, u, r) => l({
  ...r,
  queryKey: [...n.courses.reviews(e), u],
  queryFn: async () => (await c.getStudentReviews(e, u)).data,
  enabled: !!e && !!u && (r == null ? void 0 : r.enabled) !== !1
}), N = (e, u, r) => l({
  ...r,
  queryKey: [...n.courses.reviewNotes(e), u],
  queryFn: async () => (await c.getStudentReviewNotes(e, u)).data,
  enabled: !!e && !!u && (r == null ? void 0 : r.enabled) !== !1
}), P = (e) => {
  const u = q();
  return d({
    ...e,
    mutationFn: async (r) => c.resume(r),
    onSuccess: (r, s, a, ...t) => {
      var y;
      u.invalidateQueries({ queryKey: n.courses.list() }), u.invalidateQueries({ queryKey: n.courses.detail(s) }), (y = e == null ? void 0 : e.onSuccess) == null || y.call(e, r, s, a, ...t);
    }
  });
}, U = (e) => {
  const u = q();
  return d({
    ...e,
    mutationFn: async (r) => c.confirmPracticalHearing(r),
    onSuccess: (r, s, a, ...t) => {
      var y;
      u.invalidateQueries({ queryKey: n.courses.list() }), u.invalidateQueries({ queryKey: n.courses.detail(s) }), u.invalidateQueries({ queryKey: n.courses.completion(s) }), (y = e == null ? void 0 : e.onSuccess) == null || y.call(e, r, s, a, ...t);
    }
  });
}, H = (e, u) => l({
  ...u,
  queryKey: n.courses.instructors(e),
  queryFn: async () => (await c.getInstructors(e)).data,
  enabled: !!e
}), L = (e) => {
  const u = q();
  return d({
    ...e,
    mutationFn: async ({ courseId: r, userId: s }) => (await c.addInstructor(r, { userId: s })).data,
    onMutate: async (r) => {
      if (r.instructor)
        return await C(
          u,
          r.courseId,
          r.instructor
        );
    },
    onError: (r, s, a) => {
      var t;
      if (a != null && a.previousInstructors) {
        const y = n.courses.instructors(s.courseId);
        u.setQueryData(y, a.previousInstructors);
      }
      (t = e == null ? void 0 : e.onError) == null || t.call(e, r, s, a);
    },
    onSuccess: (r, s, ...a) => {
      var t;
      (t = e == null ? void 0 : e.onSuccess) == null || t.call(e, r, s, ...a);
    }
  });
}, T = (e) => {
  const u = q();
  return d({
    ...e,
    mutationFn: async ({ courseId: r, userId: s, addRemove: a }) => (await c.addMainInstructor(r, { userId: s, addRemove: a })).data,
    onSuccess: (r, s, ...a) => {
      var t;
      u.invalidateQueries({
        queryKey: n.courses.detail(s.courseId)
      }), (t = e == null ? void 0 : e.onSuccess) == null || t.call(e, r, s, ...a);
    }
  });
}, h = (e) => {
  const u = q();
  return d({
    ...e,
    mutationFn: async ({ courseId: r, userId: s }) => (await c.deleteInstructor(r, s)).data,
    onMutate: async (r) => await i(
      u,
      r.courseId,
      r.userId
    ),
    onError: (r, s, a) => {
      var t;
      if (a != null && a.previousInstructors) {
        const y = n.courses.instructors(s.courseId);
        u.setQueryData(y, a.previousInstructors);
      }
      (t = e == null ? void 0 : e.onError) == null || t.call(e, r, s, a);
    },
    onSuccess: (r, s, ...a) => {
      var t;
      (t = e == null ? void 0 : e.onSuccess) == null || t.call(e, r, s, ...a);
    }
  });
};
export {
  L as useAddCourseInstructorMutation,
  A as useAddCourseMutation,
  U as useConfirmPracticalHearingMutation,
  h as useDeleteCourseInstructorMutation,
  g as useGetAvailableCoursesQuery,
  f as useGetCourseCompletionQuery,
  H as useGetCourseInstructorsQuery,
  G as useGetCourseLessonsQuery,
  b as useGetCourseObjectivesQuery,
  v as useGetCourseQuery,
  w as useGetCoursesQuery,
  j as useGetStudentCourseQuery,
  N as useGetStudentReviewNotesQuery,
  D as useGetStudentReviewsQuery,
  M as useGetUserCoursesQuery,
  O as usePauseCourseMutation,
  R as useRemoveCourseMutation,
  P as useResumeCourseMutation,
  T as useSetMainInstructorMutation,
  E as useStartCourseMutation,
  F as useUpdateCourseStatusForAdminMutation
};
